import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipStatusComponent } from './chip-status.component';
import { MatChipsModule } from '@angular/material/chips';
import { WcgChipModule, WcgCustomPipesModule } from '@wcg/frontend-framework';
import { ERMDatePipe, ERMDateTimePipe } from '@shared/pipes/erm-date.pipe';

@NgModule({
  declarations: [ChipStatusComponent],
  imports: [
    CommonModule,
    MatChipsModule,
    WcgChipModule,
    WcgCustomPipesModule,
    ERMDatePipe,
    ERMDateTimePipe,
  ],
  exports: [ChipStatusComponent],
})
export class ChipStatusModule {}
